export default __webpack_public_path__ + "static/media/banner-1-6.6dca7fe3.png";